import React from "react";
import { Button, Badge } from "react-bootstrap";
import moment from "moment";

const ProjectPartnerTab = ({
  // Data
  partners,
  partnersLoading,
  vendorMap,
  vendorContactsMap,
  loadingVendorContacts,

  // Permissions
  hasProjectAdminRole,
  hasProjectManagerRole,

  // Handlers
  handleCreatePartner,
  handleEditPartner,
}) => {
  const canEdit = hasProjectAdminRole() || hasProjectManagerRole();

  return (
    <div className="project-view-fade-in">
      <div className="project-overview-single-card">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h3 className="project-view-overview-section-title mb-1">
              Project Partners
            </h3>
            <p className="text-muted mb-0">
              Manage partners associated with this project
            </p>
          </div>
          {canEdit && (
            <Button variant="primary" onClick={handleCreatePartner}>
              Add Partner
            </Button>
          )}
        </div>

        {partnersLoading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading partners...</span>
            </div>
          </div>
        ) : partners.length === 0 ? (
          <div className="text-center py-5 text-muted">
            <i className="fas fa-handshake fa-3x mb-3"></i>
            <h5>No Partners Found</h5>
            <p className="mb-4">
              No partners are associated with this project yet.
            </p>
            {canEdit && (
              <Button variant="outline-primary" onClick={handleCreatePartner}>
                <i className="fas fa-plus me-2"></i>
                Add Your First Partner
              </Button>
            )}
          </div>
        ) : (
          <div className="table-responsive">
            <table className="project-view-partner-table">
              <thead className="project-view-partner-table-header">
                <tr>
                  <th>Partner ID</th>
                  <th>Name</th>
                  <th>Contact Persons</th>
                  <th>Created By</th>
                  <th>Created Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className="project-view-partner-table-body">
                {partners.map((partner) => (
                  <tr key={partner.partnerId} className="partner-table-row">
                    <td className="partner-id-cell">
                      <div className="partner-id">{partner.partnerId}</div>
                    </td>
                    <td className="partner-name-cell">
                      <div className="partner-name">
                        {vendorMap[partner.partnerName]
                          ? `${vendorMap[partner.partnerName].name} (${vendorMap[partner.partnerName].vendorCode})`
                          : partner.partnerName}
                      </div>
                    </td>
                    <td className="partner-contacts-cell">
                      {loadingVendorContacts[partner.partnerName] ? (
                        <small className="text-muted">Loading...</small>
                      ) : vendorContactsMap[partner.partnerName]?.length > 0 ? (
                        <ul className="list-unstyled mb-0">
                          {vendorContactsMap[partner.partnerName].map((cp) => (
                            <li key={cp.cusVenId} className="mb-1">
                              <strong>{cp.contactPerName}</strong>
                              <br />
                              <small className="text-muted">
                                📞 {cp.contactPerNumber || "-"} | ✉️{" "}
                                {cp.contactPerEmail || "-"}
                              </small>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <small className="text-muted">No contacts</small>
                      )}
                    </td>
                    <td className="partner-createdby-cell">
                      <div className="partner-createdby">
                        {partner.createdBy || "-"}
                      </div>
                    </td>
                    <td className="partner-date-cell">
                      {partner.createdOnDate
                        ? moment(partner.createdOnDate).format("MMM DD, YYYY")
                        : "-"}
                    </td>
                    <td className="partner-actions-cell">
                      <div className="partner-actions">
                        {canEdit && (
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => handleEditPartner(partner)}
                            className="me-2"
                            title="Edit Partner"
                          >
                            Edit
                          </Button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectPartnerTab;
